import React from 'react'
import { CidadaoListagemHipertensaoQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/model-acompanhamentoCondicaoSaudeListaTematica'

import { AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanel } from '../AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanel'

interface AcompanhamentoCondicaoSaudeHipertensaoAccordionSectionProps {
  row: CidadaoListagemHipertensaoQueryModel
}

export function AcompanhamentoCondicaoSaudeHipertensaoAccordionSection({
  row,
}: Readonly<AcompanhamentoCondicaoSaudeHipertensaoAccordionSectionProps>) {
  return (
    <AcompanhamentoCondicaoSaudeVisitaDomiciliarAccordionPanel
      dataUltimasVisitasDomiciliares={
        row?.cidadao?.cidadaoConsolidado?.visitaDomiciliar?.dataUltimasVisitasDomiciliares
      }
      qtdVisitasDomiciliares={row?.cidadao?.cidadaoConsolidado?.visitaDomiciliar?.qtdVisitasDomiciliares}
    />
  )
}
